import axios from 'axios';

const api = '/api/clients';

export const getClient = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getPersonLight = personId => {
  return axios.get(`${api}/light/${personId}?cacheBuster=${new Date().getTime()}`);
};

export const getPersonById = personId => {
  return axios.get(`${api}/${personId}?cacheBuster=${new Date().getTime()}`);
};

export const searchPersons = params => {
  return axios.get(`${api}/search${params}&cacheBuster=${new Date().getTime()}`);
};

export const createNewPerson = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updatePerson = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const changePassword = account => {
  return axios.put(`${api}/changePassword?cacheBuster=${new Date().getTime()}`, account);
};

export const getClientUsage = id => {
  return axios.get(`${api}/${id}/usage?cacheBuster=${new Date().getTime()}`);
};

export const deleteClient = (id, replacementClientId) => {
  const params = replacementClientId ? `?replacementClientId=${replacementClientId}` : '';
  return axios.delete(`${api}/${id}${params}`);
};
